import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import { formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { toast } from "sonner";

export default function Auth({ mode = "login" }) {
  const isLogin = mode === "login";
  const { login, register } = useAuth();
  const { lang } = useLang();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = isLogin ? await login(form.email, form.password) : await register(form.name, form.email, form.password, lang);
      toast.success("Bienvenue chez LUXE ORYVEA");
      // Redirection selon le rôle : admin -> /admin (ou la page d'origine), sinon -> /compte
      const dest = u?.role === "admin" ? (loc.state?.from || "/admin") : (loc.state?.from || "/compte");
      const returnState = loc.state?.checkoutRequired ? { checkoutRequired: true } : undefined;
      nav(dest, { replace: true, state: returnState });
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="pt-40 pb-32 min-h-[80vh] flex flex-col items-center px-6">
      <div className="mb-10"><Logo size="md" /></div>
      <div className="card-lux p-10 w-full max-w-md">
        <h1 className="font-display text-4xl mb-8 text-center" style={{ fontWeight: 300 }}>{isLogin ? "Connexion" : "Créer un compte"}</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="auth-form">
          {!isLogin && <input required placeholder="Nom complet" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="auth-name" />}
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="auth-email" />
          <input required type="password" placeholder="Mot de passe" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="auth-password" />
          {isLogin && (
            <div className="text-right -mt-2">
              <Link to="/mot-de-passe-oublie" className="link-underline text-xs" style={{ color: "var(--lo-muted)" }} data-testid="auth-forgot-link">Mot de passe oublié ?</Link>
            </div>
          )}
          {err && <p className="text-xs" style={{ color: "#e08" }} data-testid="auth-error">{err}</p>}
          <button disabled={busy} className="btn-primary h-14 w-full disabled:opacity-50" data-testid="auth-submit">{busy ? "..." : isLogin ? "Se connecter" : "Créer mon compte"}</button>
        </form>
        <p className="text-center text-sm mt-6" style={{ color: "var(--lo-muted)" }}>
          {isLogin ? "Pas encore de compte ? " : "Déjà un compte ? "}
          <Link to={isLogin ? "/inscription" : "/connexion"} className="link-underline" style={{ color: "var(--lo-rose-hi)" }} data-testid="auth-switch">
            {isLogin ? "Créer un compte" : "Se connecter"}
          </Link>
        </p>
      </div>
    </div>
  );
}
